import { NgModule }                    from '@angular/core';
import { Routes, RouterModule }        from '@angular/router';
//import { AuthService }                 from './auth/ind/auth.service';
//import { AuthGuardService }            from './auth/ind/auth-guard.service';
//import { OrgAuthService }              from './auth/org/orgauth.service';
//import { OrgAuthGuardService }         from './auth/org/orgauth-guard.service';
//import { AdmAuthGuardService }         from './auth/adm/admauth-guard.service';
//import { LoginComponent }              from './login/login.component';
//import { LoginOrgComponent }           from './login/loginorg.component';

import { RegisterComponent }           from './login/register/register.component';
import { ForgotPasswordComponent }     from './login/forgot-password/forgot-password.component';
import { ResetPasswordComponent }      from './login/reset-password/reset-password.component';
import { ActivateComponent }           from './login/activate/activate.component';
import { StartProcessComponent}        from './login/start-process/start-process.component';

import { OrgRegisterComponent }        from './login/orgregister/orgregister.component';
import { OrgForgotPasswordComponent }  from './login/orgforgot-password/orgforgot-password.component';
import { OrgResetPasswordComponent }   from './login/org-reset-password/org-reset-password.component';
import { ShareParamService }           from './_services/index';
//import { RaterFormComponent }         from './raterform/rater-form.component';

//import {LoginModule} from './login/login.module';

//export function loadLoginModule() { return LoginModule; }

const appRoutes: Routes = [
  /*{
    {
    path: 'admin',
    loadChildren: 'app/admin/admin.module#AdminModule',
    canLoad: [AuthGuard]
  },
  {
    path: '',
    loadChildren: 'app/crisis-center/crisis-center.module#CrisisCenterModule',
    data: { preload: true }
  },*/

/*{
    path: 'ind',
    loadChildren: loadLoginModule
    // Comment loadChildren above and uncomment the line below to get non lazy loading working with AoT
    // Do not delete / comment the  `loadLoginModule` declaration or the module will be lazy loaded
    // loadChildren: './bundled/bundled.module#BundledModule'
  },*/


  { path: '', redirectTo: 'ind', pathMatch: 'full' },
  { path: 'ind-login', redirectTo: 'ind', pathMatch: 'full' },
  { path: 'ind-register', component: RegisterComponent },    
  { path: 'ind-activate/:s', component: ActivateComponent },        
  { path: 'ind-forgot-password', component: ForgotPasswordComponent },    
  { path: 'ind-reset-password/:s', component: ResetPasswordComponent },      

  { path: 'ind', loadChildren: () => import('./ind/ind.module').then(m => m.IndModule)},

  { path: 'ind-start-process/:s', component: StartProcessComponent },      
  
  { path: 'org', loadChildren: () => import('./org/org.module').then(m => m.OrgModule)},

  { path: 'org-login', redirectTo: 'org', pathMatch: 'full' },
  { path: 'org-register', component: OrgRegisterComponent },    
  { path: 'org-forgot-password', component: OrgForgotPasswordComponent },    
  { path: 'org-reset-password/:s', component: OrgResetPasswordComponent },    

  // { path: 'rater-form/:s', component: RaterFormComponent },   
  { path: 'rater-form/:s', loadChildren: () => import('./raterform/raterform.module').then(m => m.RaterformModule)}, 

  { path: 'adm', loadChildren: () => import('./adm/adm.module').then(m => m.AdmModule)},
  
  { path: 'q/:r/:a/:t/:g', loadChildren: () => import('./q/q.module').then(m => m.qModule)},
  
  { path: 'pdf/:r/:i/:t', loadChildren: () => import('./pdf/pdf.module').then(m => m.PdfModule)},
  { path: 'pdfind/:r/:i/:s/:t', loadChildren: () => import('./pdfind/pdfind.module').then(m => m.PdfIndModule)},
  
  { path: '**', redirectTo: 'ind' },
  //{ path: 'org-login', loadChildren: './org/org.module#OrgModule', canLoad: [OrgAuthGuardService] },  
  //{ path: 'adm', loadChildren: 'org/org.module#LazyModule', canLoad: [AdmAuthGuardService] },

];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    ShareParamService,
    //AuthGuardService,
    //AuthService,
    //OrgAuthGuardService,
    //OrgAuthService
  ]
})
export class AppRoutingModule { }
